export const environment = {
  production: true,
  environment_name: 'woodlands',
  environment_title: 'Woodlands Boulevard',
  environment_url: 'https://woodlandsboulevard.co.za/',
  environment: 'prod',
  api_base_url: 'https://api.hyprop.co.za/',
  api_auth_url: 'https://auth-api.hyprop.co.za/',
  cdn_url: 'https://cdn.hyprop.co.za/',
  mall_id: 'de2b5304-d22a-43b0-bffe-2307ba1fb764',
  addressLat: -25.82369201815597,
  addressLng: 28.31387692620774,
  cinemaID: 26,
  recaptcha_key: '6LeJuCcbAAAAAMiZ_rBgq7NTiEQVrjNZ1J6f1zAL',
  social_google_key:
    '150343683952-08m97b42cr2fc2v4j1qnckfmq1np0hn9.apps.googleusercontent.com',
  social_facebook_key: '253233436432992',
  sso_url: 'https://sso.hyprop.co.za',
  google_verification: 'HlwBwsWVru6R5oSc00GFUPTkn8MdF0W6N5fibKPRhL4',
  street_address:
    'Cnr Garsfontein Rd &, De Villebois Mareuil Dr, Pretoriuspark',
  address_locality: 'Pretoria',
  postal_code: '0081',
  address_country: 'ZA',
  contact_form_uuid: 'amxn7oyw',
  google_api_key: 'AIzaSyCEvUD2-2IuJdnY4mCmiPHjrdjDsskcTG8',
  form4_link:
    'https://cdn.hyprop.co.za/document/2024/2/19/b2213e98-9cbe-4799-9eb2-b336daeca01f/11e16c5e-b384-447e-b767-91e6055fccf1.pdf',
  tiktok_url: 'https://www.tiktok.com/@woodlands_boulevard',
  sitemap_image:
    'https://cdn.hyprop.co.za/image/2021/8/29/7fddb280-071b-4634-a22b-86a8ddce6b88/8b4eeed0-5535-40ae-92e5-9c8326fb36aa.jpg',
  error_image:
    'https://cdn.hyprop.co.za/image/2023/11/23/76b0cd18-b44c-496e-b375-c02f7691a976/d3f0a0ac-bc9a-49e5-b636-bc8ac1d8edd6.jpg',
};
